import type { RoomId } from '@/core/content/ids';
import type { GameSave } from '@/app/services';

/** The room the player is standing in (Nhà, Tiệm or Studio NANO). */
export function currentRoom(s: GameSave): RoomId {
  const scene = s.lastSession.sceneId;
  return scene === 'townmap' ? 'home' : scene;
}
